import { TicketForm } from "@features/tickets/components/form/TicketForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const ticketCreateSearchSchema = z.object({
  from: z.string().optional(),
  error_status: z.string().optional(),
  error_message: z.string().optional(),
});

export const Route = createFileRoute("/_app/tickets/create")({
  loader: requirePermission(PERMISSIONS.TICKETS.TICKETS.CREATE),
  staticData: {
    title: "Créer un ticket",
    showInTab: false,
    showInBreadcrumb: true,
  },
  validateSearch: ticketCreateSearchSchema,
  component: TicketCreatePage,
});

function TicketCreatePage() {
  const search = Route.useSearch();

  const hasFrom = Boolean(search.from);
  const hasError = Boolean(search.error_status || search.error_message);

  const initialData =
    hasFrom || hasError
      ? {
          ...(hasError && {
            title: search.error_status ? `Erreur ${search.error_status}` : undefined,
            description: search.error_message ?? undefined,
          }),
          routeEntries: hasFrom
            ? [{ route: search.from, routeTitle: "", apiEndpoint: "", errorMessage: "" }]
            : undefined,
        }
      : undefined;

  return <TicketForm mode="create" initialData={initialData} />;
}
